export default "__VITE_ASSET__6e378f26__"